import {
  HttpContextToken,
  type HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { filter, first, map, switchMap, tap } from 'rxjs';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';

export const USER_REFRESH_TOKEN = new HttpContextToken<boolean>(() => false);

export const userRefreshhInterceptor: HttpInterceptorFn = (req, next) => {
  const refresh = req.context.get(USER_REFRESH_TOKEN);
  if (!refresh) {
    return next(req);
  }
  const auth = inject(AuthService);
  const loading$ = auth.userLoading.pipe(first((loading) => loading));
  const notLoading$ = loading$.pipe(
    switchMap(() => auth.userLoading.pipe(first((loading) => !loading))),
  );
  return next(req).pipe(
    filter((res) => res instanceof HttpResponse && res.ok),
    tap(() => auth.refreshUser()),
    switchMap((res) =>
      loading$.pipe(switchMap(() => notLoading$.pipe(map(() => res)))),
    ),
  );
};
